import { render, staticRenderFns } from "./survey-law-subjects-modal.vue?vue&type=template&id=617f7b51&scoped=true"
import script from "./survey-law-subjects-modal.vue?vue&type=script&lang=js"
export * from "./survey-law-subjects-modal.vue?vue&type=script&lang=js"
import style0 from "./survey-law-subjects-modal.vue?vue&type=style&index=0&id=617f7b51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617f7b51",
  null
  
)

export default component.exports